import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory, generatePath } from 'react-router'
import { Button, EditFillIcon } from '@okcredit/web-lib'
import { IAppState } from 'infra/AppState'
import { AuthStorageInstance } from 'services/Storage/AuthStorage'
import { THEME } from 'components/theme'
import { ProfilePhotoAvatar } from 'components/ProfilePhotoPicker/ProfilePhotoAvatar'
import { newPaths } from 'routes'
import { BodyHeaderStyles } from './styles'

const BodyHeader = () => {
  const { t } = useTranslation()
  const { merchantProfile } = useSelector((app: IAppState) => app.Dashboard)
  const classes = BodyHeaderStyles()
  const history = useHistory()
  const currentBusinessId = AuthStorageInstance.getCurrentBusinessId() || merchantProfile?.data?.id

  const handleManageAccountClick = (e: any) => {
    e.stopPropagation()
    history.push({
      pathname: generatePath(newPaths.editMerchant, { id: currentBusinessId }),
      search: ''
    })
  }

  return (
    <div className={classes.selectorBodyHeader}>
      {/* Same business photo flow as the profile drawer: pencil badge → Delete / Choose photo
          sheet (anchored to this drawer) → Google Drive upload */}
      <ProfilePhotoAvatar
        target={{ kind: 'business' }}
        imageUrl={merchantProfile?.data?.profileImage}
        name={merchantProfile?.data?.name}
        size={96}
        source="business_switcher"
      />
      <div className={classes.businessName}>{merchantProfile?.data?.name}</div>
      <Button
        size="medium"
        variant="outlined"
        color="primary"
        startIcon={<EditFillIcon fill={THEME.brandGreen} size={24} />}
        onClick={handleManageAccountClick}
      >
        {t('dashboard:Manage Business')}
      </Button>
    </div>
  )
}

export default BodyHeader
